import { Box, Card, CardContent, InputAdornment, TextField, Typography } from '@material-ui/core';
import Avatar from '@material-ui/core/Avatar';
import Grid from '@material-ui/core/Grid';
import SearchIcon from '@material-ui/icons/Search';
import React, { useEffect, useState } from 'react';


const transformProps = {
    label: 'label',
    value: 'label',
    description: 'description',
    category: 'category',
}

const MultiorSingleValueSelectorCard = ({ size = 12, label, name, isSearchable = true, height = '100%', isMultiple = true, value, isGroupable = false, handleFieldValue, items = [], extraProps = null }) => {
    const { transformProps } = extraProps || transformProps;
    // const [valArray, setValArray] = useState(value ? value.split(',') : [])
    const [valArray, setValArray] = useState(value ? value : [])
    const [searchText, setSearchText] = useState('');
    const [cardGroups, setCardGroups] = useState({});
    const [cards, setCards] = useState(items || [])

    useEffect(() => {
        if (searchText === '' && items && items.length > 0) {
            setCards(items);
            const cardGroups = items.reduce((groups, card) => {
                const category = card[(transformProps && transformProps.category)];
                if (!groups[category]) {
                    groups[category] = [];
                }
                groups[category].push(card);
                return groups;
            }, {});
            setCardGroups(cardGroups)
        }
    }, [])

    const handleSearchChange = (event) => {
        let tempcards = items;
        const filteredCards = tempcards.filter(card => {
            if (card[(transformProps && transformProps.label)] && card[(transformProps && transformProps.label)].toLowerCase().includes(event.target.value.toLowerCase()))
                return card
            else if (card[(transformProps && transformProps.description)] && card[(transformProps && transformProps.description)].toLowerCase().includes(event.target.value.toLowerCase()))
                return card;
            return false
        });

        const cardGroups = filteredCards.reduce((groups, card) => {
            const category = card[(transformProps && transformProps.category)];
            if (!groups[category]) {
                groups[category] = [];
            }
            groups[category].push(card);
            return groups;
        }, {});

        setSearchText(event.target.value);
        setCards(filteredCards);
        setCardGroups(cardGroups);

    };

    const handleCardClick = (cardValue) => {
        let newValue = [...valArray];
        const index = newValue.indexOf(cardValue);

        if (isMultiple) {
            if (index > -1) {
                newValue.splice(index, 1); // remove the value from the array
            } else {
                newValue.push(cardValue); // add the value to the array
            }
        } else {
            newValue = [cardValue]; // replace the current value with the new one
        }

        console.log(newValue.join(','));
        let e = { target: { name: name, value: newValue }, currentTarget: { dataset: null } }
        setValArray(newValue)
        handleFieldValue(e);
    };

    return (
        <Box className={'col-' + size} style={{ margin: 2 }}>
            <Typography variant="h6" component="h2">                {label}            </Typography>
            {isSearchable && <TextField
                fullWidth
                variant="outlined"
                value={searchText}
                size="small"
                onChange={handleSearchChange}
                style={{ backdropFilter: 'blur(4px)' }}
                InputProps={{
                    endAdornment: (
                        <InputAdornment position="end">
                            <SearchIcon />
                        </InputAdornment>
                    ),
                }}
            />}
            <div style={{ maxHeight: height, overflowY: 'auto', width: '100%' }}>
                {isGroupable ? Object.entries(cardGroups).map(([title, cards]) => (
                    <div key={title}>
                        <Typography variant="body" >
                            {title}
                        </Typography>
                        {cards.map((card, index) => (
                            <CardComponent card={card} index={index} handleCardClick={handleCardClick} transformProps={transformProps} valArray={valArray} />
                        ))}
                    </div>
                )) : <>
                    {cards.map((card, index) => (
                        <CardComponent card={card} index={index} handleCardClick={handleCardClick} transformProps={transformProps} valArray={valArray} />
                    ))}
                </>
                }
            </div>
        </Box>

    );
};

export default MultiorSingleValueSelectorCard;


function CardComponent({ index, card, handleCardClick, valArray, transformProps }) {

    return <Card key={index}
        className='m-1'
        onClick={() => handleCardClick(card[(transformProps && transformProps.value)])}
        style={valArray && valArray.length > 0 && valArray.includes(card[(transformProps && transformProps.value)]) ?
            {
                backgroundColor: 'rgba(255, 255, 255, 0.7)',
                backdropFilter: 'blur(10px)',
                border: '1px solid #2196f3',
                boxShadow: '0 1px 0px 0 #2196f3, 0 0px 0px 0 #2196f3'
            } : {}}
    >
        <CardContent>
            <Grid container alignItems="center" spacing={2}>
                {card.icon &&
                    <Grid item>
                        <Avatar src={card.icon} />
                    </Grid>
                }
                <Grid item xs>
                    <Typography variant="subtitle2" >
                        {card[(transformProps && transformProps.label)]}
                    </Typography>
                    <Typography variant="caption" color="textSecondary" >
                        {card[(transformProps && transformProps.description)]}
                    </Typography>
                </Grid>
            </Grid>
        </CardContent>
    </Card>
}
